import React, { useState, useEffect } from "react";
import PosterServices from "../../services/BannerServices";
import MembershipServiceListServices from "../../services/MembershipServiceListServices";
import { useNavigate } from 'react-router-dom';
function UpdatePoster({ happy, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    serviceId: "",
    title: "",
    image: "", // URL or File object
  });
  const navigate = useNavigate();
  const [previewImage, setPreviewImage] = useState("");
  const BASE_URL = process.env.REACT_APP_URL; // use env URL
  const [services, setServices] = useState([]);
  useEffect(() => {
    if (happy) {
      const imgUrl = happy?.image ? `${BASE_URL}${happy.image}` : "";
      setFormValues({
        serviceId: happy?.serviceId?._id || happy?.serviceId || "",
        title: happy?.title || "",
        image: happy?.image || "",
      });
      setPreviewImage(imgUrl);
    }
  }, [happy, BASE_URL]);
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await MembershipServiceListServices.getServiceGuest();

        if (res?.status) {
          const formatted = res.data.map(item => ({
            _id: item._id,
            title: item.title
          }));

          setServices(formatted);
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchServices();
  }, []);
  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image" && files?.length > 0) {
      // file upload
      const file = files[0];
      setFormValues({ ...formValues, image: file });
      setPreviewImage(URL.createObjectURL(file)); // blob preview
    } else {
      // URL input
      setFormValues({ ...formValues, [name]: value });
      if (name === "image") setPreviewImage(`${BASE_URL}${value}`);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let payload;
      const selectedService = services.find(
        s => s._id === formValues.serviceId
      );
      if (formValues.image instanceof File) {
        payload = new FormData();
        payload.append("serviceId", selectedService?._id);
        payload.append("title", formValues.title);
        payload.append("image", formValues.image);
      } else {
        payload = {
          serviceId: selectedService?._id,
          title: formValues.title,
          image: formValues.image, // URL
        };
      }

      // await PosterServices.updatePoster(happy._id, payload);

      // alert("Happy Customer updated successfully");
      // onSuccess();
      // closeModal();


      const response = await PosterServices.updatePoster(happy._id, payload);;
      if (response && response.data) {
        alert(response.message);
        onSuccess();
        closeModal();
        navigate("/poster-list");
      } else {
        alert('Failed to update ❌');
      }

    } catch (err) {
      console.error("Failed to update Happy Customer:", err);
      alert("Failed to update Happy Customer");
    }
  };

  return (
    <div className="modal fade edit-box show d-block" tabIndex={-1}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit Poster</h5>
            <button type="button" className="btn-close" onClick={closeModal} />
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label>Service Service</label>
                <select
                  name="serviceId"
                  className="form-control"
                  value={formValues.serviceId}
                  onChange={handleInputChange}
                  
                >
                  <option value="">Select Service</option>
                  {services.map(s => (
                    <option key={s._id} value={s._id}>
                      {s.title}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-3">
                <label>Title</label>
                <input
                  type="text"
                  name="title"
                  className="form-control"
                  value={formValues.title}
                  onChange={handleInputChange}
                  
                />
              </div>
              <div className="mb-3">
                <label>Image (URL or file)</label>
                {/* <input
                  type="text"
                  name="image"
                  className="form-control mb-2"
                  placeholder="Enter image URL"
                  value={formValues.image instanceof File ? "" : formValues.image}
                  onChange={handleInputChange}
                /> */}
                <input
                  type="file"
                  name="image"
                  className="form-control"
                  accept="image/*"
                  onChange={handleInputChange}
                />
              </div>

              {previewImage && (
                <div className="mb-3">
                  {/* <label>Preview:</label> */}
                  <img
                    src={previewImage}
                    alt="Preview"
                    style={{
                      width: "110px",
                      height: "110px",
                      objectFit: "cover",
                      borderRadius: "10px",
                      border: "1px solid #ddd",
                      transition: "0.3s",
                      // cursor: "pointer"
                    }}
                  />
                </div>
              )}

              <button type="submit" className="btn btn-success">
                Update
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdatePoster;